var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"wf-editor",attrs:{"title":"流程图预览","width":1100,"visible":_vm.visible,"maskClosable":true,"confirmLoading":_vm.modalLoading,"footer":null,"destroyOnClose":""},on:{"cancel":_vm.onCancel}},[_c('div',{staticStyle:{"width":"1100px","height":"500px","margin-bottom":"4px"},attrs:{"id":"WFContainer","tabindex":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }